export interface SignupWindow {
  status: string;
  registrationEndDate: string | null;
}

// Mirrors the backend gate: a tournament whose deadline has passed still reads
// REGISTRATION_OPEN, so the status alone would offer a button the API refuses.
// The deadline day itself still counts as open.
export function isSignupOpen(window: SignupWindow, now: Date): boolean {
  if (window.status !== 'REGISTRATION_OPEN') {
    return false;
  }

  if (!window.registrationEndDate) {
    return true;
  }

  const deadline = new Date(window.registrationEndDate);
  deadline.setUTCHours(23, 59, 59, 999);

  return now.getTime() <= deadline.getTime();
}

// Latecomers are not turned away: past the deadline — and past the organiser
// closing registration by hand — entries keep arriving onto a waiting list until
// play starts. Mirrors signupPhase() in tournament-api/lifecycle/managed-signup.ts.
const WAITLIST_STATUSES = ['REGISTRATION_OPEN', 'REGISTRATION_CLOSED', 'SCHEDULING'];

export type SignupPhase = 'OPEN' | 'WAITLIST' | 'CLOSED';

export function signupPhase(window: SignupWindow, now: Date): SignupPhase {
  if (isSignupOpen(window, now)) {
    return 'OPEN';
  }

  if (WAITLIST_STATUSES.includes(window.status)) {
    return 'WAITLIST';
  }

  return 'CLOSED';
}
